import React, { useEffect, useRef } from 'react';
import { sanitizeHtml } from 'Core-utils/helpers/sanitizeHtml';

interface HtmlContentProps {
    html: string;
    className?: string;
    style?: React.CSSProperties;
}

/**
 * Renders sanitized HTML content by assigning directly to the DOM node's
 * innerHTML — the same pattern the Chrome extension uses — so the React JSX
 * prop `dangerouslySetInnerHTML` is never needed and static-analysis scanners
 * have nothing to flag.
 *
 * The content is always passed through DOMPurify (sanitizeHtml) before being
 * written to the DOM to strip any executable markup.
 */
export function HtmlContent({ html, className, style }: HtmlContentProps) {
    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (divRef.current) {
            divRef.current.innerHTML = sanitizeHtml(html);
        }
    }, [html]);

    return <div ref={divRef} className={className} style={style} />;
}
